/**
 * Centralized query keys for automation-related queries.
 * Use these constants to ensure consistency across queries and invalidations.
 */
export const AUTOMATION_QUERY_KEYS = {
	/** Base key for all automation queries */
	all: ['automations'] as const,

	/** List of all automation templates */
	templates: () => [...AUTOMATION_QUERY_KEYS.all, 'templates'] as const,

	/** Single automation template by ID */
	template: (templateId: string) => [...AUTOMATION_QUERY_KEYS.templates(), templateId] as const,

	/** Automation template steps */
	templateSteps: (templateId: string) => [...AUTOMATION_QUERY_KEYS.template(templateId), 'steps'] as const,

	/** Automation on-hold contacts */
	onHold: () => [...AUTOMATION_QUERY_KEYS.all, 'onhold'] as const,

	/** On-hold contacts for a specific template */
	onHoldContacts: (templateId: string) => [...AUTOMATION_QUERY_KEYS.onHold(), templateId] as const,

	/** Automations on hold summary (for nav badge) */
	onHoldSummary: () => [...AUTOMATION_QUERY_KEYS.onHold(), 'summary'] as const,

	/** Contact automations (running automations for a contact) */
	contactAutomations: (contactId: string) => [...AUTOMATION_QUERY_KEYS.all, 'contact', contactId] as const,
} as const;
